import React from "react";
import { UserProfile } from "../../../Entities/UserProfile";
import {
  CalendarOutlined,
  DownloadOutlined,
  EyeOutlined,
  FileOutlined,
} from "@ant-design/icons";
import { Button, Tooltip, Typography } from "antd";
import dayjs from "dayjs";

interface CandidateResumeCardProps {
  userProfile: UserProfile;
  handleViewResume: (resume: UserProfile) => void;
  handleDownloadResume: (resume: UserProfile) => Promise<void>;
}

const CandidateResumeCard: React.FC<CandidateResumeCardProps> = ({
  userProfile,
  handleViewResume,
  handleDownloadResume,
}) => {
  const { filename, createdAt, lastUsedAt, summary } = userProfile;
  return (
    <div className="candidate-resume-card">
      <div className="candidate-resume-card-header">
        <div className="candidate-resume-card-header-icon">
          <FileOutlined />
        </div>
        <Typography.Text strong>{filename}</Typography.Text>
      </div>
      <Typography.Paragraph
        type="secondary"
        style={{ fontStyle: "italic", margin: 0 }}
        ellipsis={{ rows: 2 }}
      >
        {summary}
      </Typography.Paragraph>
      <div className="candidate-resume-card-meta">
        <Typography.Text className="candidate-resume-card-meta__item">
          <CalendarOutlined /> Uploaded on{" "}
          {dayjs(createdAt).format("DD MMM YYYY hh:mm A")}
        </Typography.Text>
        {lastUsedAt && (
          <Typography.Text className="candidate-resume-card-meta__item">
            <CalendarOutlined /> Last used on{" "}
            {dayjs(lastUsedAt).format("DD MMM YYYY hh:mm A")}
          </Typography.Text>
        )}
      </div>
      <div className="candidate-resume-card-actions">
        <Tooltip placement="bottom" title="View Resume">
          <Button
            icon={<EyeOutlined />}
            iconPosition="end"
            onClick={() => handleViewResume(userProfile)}
          />
        </Tooltip>
        <Tooltip placement="bottom" title="Download Resume">
          <Button
            icon={<DownloadOutlined />}
            iconPosition="end"
            onClick={() => handleDownloadResume(userProfile)}
          />
        </Tooltip>
      </div>
    </div>
  );
};

export default CandidateResumeCard;
